$(document).ready(function () {
  // STICKY HEADER ON SCROLL
  // $(window).scroll(function () {
  //   if ($(window).scrollTop() >= 40) {
  //     $(".header").addClass("fixed-header");
  //   } else {
  //     $(".header").removeClass("fixed-header");
  //   }
  // });
  window.addEventListener("scroll", () => {
    const header = document.querySelector("header");
    const headerTop = header.getBoundingClientRect().top;
    if (headerTop <= 0) {
      header.classList.add("fixed-header");
    } else {
      header.classList.remove("fixed-header");
    }
  });
   // SHOP KASTEN CARD SLIDER
  const ShopKastenSlider = $(".shop-kasten-slider");
  const FourProgressBar = $(".progressBar4");
  ShopKastenSlider.on("init", function (event, slick) {
    updateProgressBar(ShopKastenSlider, FourProgressBar);
  });
  ShopKastenSlider.on("afterChange", function (event, slick) {
    updateProgressBar(ShopKastenSlider, FourProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $FourStatus = $(".pagingInfo4");
  var $ShopKastenSlider = $(".shop-kasten-slider");
  $ShopKastenSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $FourStatus.text(i + "/" + slick.slideCount);
    }
  );
  ShopKastenSlider.slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 2000,
    settings: "unslick",
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          dots: true,
          infinite: true,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.7,
          dots: true,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1.4,
          dots: true,
        },
      },
    ],
  });
  // SHOP KASTEN LIST SLIDER and COLLECTION DETAILS USP SLIDER COMMON
  $(document).ready(function(){
    $(".shop-kasten-lists-slider").slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 500,
      settings: "unslick",
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick",
        },
        {
          breakpoint: 1400,
          settings: {
            autoplay: true,
            infinite: true,
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            autoplay: true,
            infinite: true,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            autoplay: true,
            infinite: true,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            autoplay: true,
            infinite: true,
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 576,
          settings: {
            autoplay: true,
            infinite: true,
            slidesToShow: 1,
          },
        },
      ],
    });
  });
  // TOGGLE MENU OPEN
$(".hamburger").click(function () {
  $(".mobile-toggle").addClass("is-active");
  $("header").addClass("is-active");
  $("body").addClass("overflow-hidden");
});

$(".navbar-close .menu-close").click(function () {
  $(".mobile-toggle").removeClass("is-active");
  $("body").removeClass("overflow-hidden");

  // Set a timeout to remove the header class after 3 seconds
  setTimeout(function () {
    $("header").removeClass("is-active");
  }, 3000); // 3000 milliseconds = 3 seconds
});
  // COLLECTION DETAIL INFORMATION CONTENT SHOW
  $(".information-box .show-more").click(function () {
    $(".information-box").each(function () {
      $(this).parent().removeClass("box-active");
    });
    $(this).parent().toggleClass("box-active");
  });
  $('.information-box .show-more').click(function(){
    var $this = $(this);
    $this.toggleClass('SeeMore');
    if($this.hasClass('SeeMore')){
        $this.html('<img src="https://cdn.shopify.com/s/files/1/0474/0454/8262/files/down-arrow-black.svg?v=1726293757" alt="down-arrow"> Zobrazit méně');
    } else {
      $this.html('<img src="https://cdn.shopify.com/s/files/1/0474/0454/8262/files/down-arrow-black.svg?v=1726293757" alt="down-arrow"> Zobrazit více');  
    }
});
  /* **** FILTER SIDEBAR START **** */
  $(".filter-modal .filter-btn").click(function () {
    $(".mobile-filter-sidebar").toggleClass("show");
  });
  $(".mobile-filter-sidebar .filter-close").click(function () {
    $(".mobile-filter-sidebar").removeClass("show");
  });
  // COLLECTION PAGE ON SCROLL STICKY FILTER
  $(window).bind("scroll", function () {
    var navHeight = $(".collection-banner").height();
    if ($(window).scrollTop() > navHeight) {
      $(
        ".collection-product-details , .all-collection-wrap .facets-wrapper"
      ).addClass("sticky");
    } else {
      $(
        ".collection-product-details , .all-collection-wrap .facets-wrapper"
      ).removeClass("sticky");
    }
  });
  // SHUBMENU OPEN
  const multiLevelMenu = document.querySelector(".mobile-filter-sidebar");
  $(".mobile-filter-sidebar").each(function (index, mlMenu) {
    var subMenuItems = $(mlMenu).find(".hasSubMenu");
    console.log("subMenuItems", subMenuItems);
    subMenuItems.each(function (i, subMenu) {
      $(subMenu)
        .find(".trigger")
        .on("click", function () {
          var target = $(subMenu).attr("data-target");
          $(target).addClass("active");
        });
    });
    $(".backTrigger").on("click", function () {
      var _backTrigger = this;
      $(_backTrigger).parents(".subMenu").removeClass("active");
    });
  });
  /* **** FILTER SIDEBAR START **** */
 
  // HOME BANNER LIST SLIDER
  $(".home-banner-list-slider").slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    settings: "unslick",
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 1400,
        settings: {
          autoplay: true,
          infinite: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          autoplay: true,
          infinite: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          autoplay: true,
          infinite: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: true,
          infinite: true,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          autoplay: true,
          infinite: true,
          slidesToShow: 1,
        },
      },
    ],
  });
   // RELATED PRODUCT CARD SLIDER
  $(".product-card-related-wrap").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 2,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1.7,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  //CATEGORIES SECTION SLIDER
  const categorieSlider = $(".categorie-slider");
  var categorieProgressBar = $(".progressBar1");
  categorieSlider.on("init", function (event, slick, currentSlide, nextSlide) {
    currentDot = $(".slick-dots .slick-active").index() + 1;
    dots = categorieSlider.find(".slick-dots li").length;
    calc = (currentDot / dots) * 100;
    categorieProgressBar
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  });
  categorieSlider.on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var currentDot = $(".slick-dots .slick-active").index() + 1;
      var dots = categorieSlider.find(".slick-dots li").length;
      // console.log("currentdots", currentDot);
      // console.log("dots===", dots);
      var calc = (currentDot / dots) * 100;
      categorieProgressBar
        .css("background-size", calc + "% 100%")
        .attr("aria-valuenow", calc);
    }
  );
  var $status = $(".pagingInfo");
  var $categorieSlider = $(".categorie-slider");
  $categorieSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + "/" + slick.slideCount);
    }
  );
  categorieSlider.slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    autoplay: false,
    arrows: true,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 5,
          dots: false,
          infinite: false,
          autoplay: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          dots: false,
          infinite: false,
          autoplay: false,
          arrows: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          dots: false,
          infinite: false,
          autoplay: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: "unslick",
      },
    ],
  });
  // BEST SELLERS SECTION SLIDER
  const BestSellerSlider = $(".best-sellers-slider");
  const secondProgressBar = $(".progressBar2");
  BestSellerSlider.on("init", function (event, slick) {
    updateProgressBar(BestSellerSlider, secondProgressBar);
  });
  BestSellerSlider.on("afterChange", function (event, slick) {
    updateProgressBar(BestSellerSlider, secondProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $SecondStatus = $(".pagingInfo2");
  var $BestSellerSlider = $(".best-sellers-slider");
  $BestSellerSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $SecondStatus.text(i + "/" + slick.slideCount);
    }
  );
  BestSellerSlider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.5,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.7,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1.4,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1.2,
          dots: true,
          arrows: false,
        },
      },
    ],
  });
  // SPOTLIGHT SECTION SLIDER
  const $SpotlightSlider = $(".spotlight-slider");
  const $SpotlightProgressBar = $(".progressBar-spotlight");
  const $SpotlightStatus = $(".pagingInfo-spotlight");
  const $window = $(window);
  const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          dots: true,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          dots: true,
          infinite: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          dots: true,
          infinite: false,
        },
      },
    ],
  };
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    if (dots > 0) {
      const calc = (currentDot / dots) * 100;
      progressBarElement
        .css("background-size", calc + "% 100%")
        .attr("aria-valuenow", calc);
    } else {
      progressBarElement
        .css("background-size", "0% 100%")
        .attr("aria-valuenow", 0);
    }
  }
  function initializeSlider() {
    $SpotlightSlider
      .on("init", function (event, slick) {
        updateProgressBar($SpotlightSlider, $SpotlightProgressBar);
        const i = (slick.currentSlide ? slick.currentSlide : 0) + 1;
        $SpotlightStatus.text(i + "/" + slick.slideCount);
      })
      .on("afterChange", function (event, slick, currentSlide) {
        updateProgressBar($SpotlightSlider, $SpotlightProgressBar);
        const i = currentSlide + 1;
        $SpotlightStatus.text(i + "/" + slick.slideCount);
      });
    $SpotlightSlider.slick(settings);
  }
  if ($window.width() <= 991) {
    initializeSlider();
    // initializeSlider2();
  }
  $window.on("resize", function () {
    if ($window.width() > 991) {
      if ($SpotlightSlider.hasClass("slick-initialized")) {
        $SpotlightSlider.slick("unslick");
      }
      if ($SpotlightSlider2.hasClass("slick-initialized")) {
        $SpotlightSlider2.slick("unslick");
      }
    } else {
      if (!$SpotlightSlider.hasClass("slick-initialized")) {
        setTimeout(() => {
          initializeSlider();
        }, 100);
      }
      if (!$SpotlightSlider2.hasClass("slick-initialized")) {
        setTimeout(() => {
          // initializeSlider2();
        }, 100);
      }
    }
  });
                // Discover Funiture SECTION SLIDER
            const DiscoverFurnitureSlider = $(".discover-furniture-slider");
            const tenProgressBar = $(".progressBar10");
            const $tenStatus = $(".pagingInfo10");

            DiscoverFurnitureSlider.on("init reInit afterChange", function (event, slick, currentSlide) {
                let i = (typeof currentSlide !== 'undefined' ? currentSlide : slick.currentSlide) + 1;
                $tenStatus.text(i + "/" + slick.slideCount);
                updateProgressBar(DiscoverFurnitureSlider, tenProgressBar);
            });

            function updateProgressBar(sliderElement, progressBarElement) {
                const dots = sliderElement.find(".slick-dots li").length;
                const currentDot = sliderElement.find(".slick-dots .slick-active").index() + 1;

                if (dots > 0 && currentDot > 0) {
                    const calc = (currentDot / dots) * 100;
                    progressBarElement
                        .css("background-size", calc + "% 100%")
                        .attr("aria-valuenow", calc);
                }
            }

            DiscoverFurnitureSlider.slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                infinite: false,
                speed: 300,
                autoplay: false,
                autoplaySpeed: 2000,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 5,
                            dots: true,
                            infinite: true,
                        },
                    },    
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                            dots: true,
                            infinite: true,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            dots: true,
                            infinite: false,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1.75,
                            dots: true,
                            infinite: false,
                        },
                    },
                ],
            });

  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    if (dots > 0) {
      const calc = (currentDot / dots) * 100;
      progressBarElement
        .css("background-size", calc + "% 100%")
        .attr("aria-valuenow", calc);
    } else {
      progressBarElement
        .css("background-size", "0% 100%")
        .attr("aria-valuenow", 0);
    }
  }
  function initializeSlider() {
    $SpotlightSlider
      .on("init", function (event, slick) {
        updateProgressBar($SpotlightSlider, $SpotlightProgressBar);
        const i = (slick.currentSlide ? slick.currentSlide : 0) + 1;
        $SpotlightStatus.text(i + "/" + slick.slideCount);
      })
      .on("afterChange", function (event, slick, currentSlide) {
        updateProgressBar($SpotlightSlider, $SpotlightProgressBar);
        const i = currentSlide + 1;
        $SpotlightStatus.text(i + "/" + slick.slideCount);
      });
    $SpotlightSlider.slick(settings);
  }
  if ($window.width() <= 991) {
    initializeSlider();
    // initializeSlider2();
  }
  $window.on("resize", function () {
    if ($window.width() > 991) {
      if ($SpotlightSlider.hasClass("slick-initialized")) {
        $SpotlightSlider.slick("unslick");
      }
      if ($SpotlightSlider2.hasClass("slick-initialized")) {
        $SpotlightSlider2.slick("unslick");
      }
    } else {
      if (!$SpotlightSlider.hasClass("slick-initialized")) {
        setTimeout(() => {
          initializeSlider();
        }, 100);
      }
      if (!$SpotlightSlider2.hasClass("slick-initialized")) {
        setTimeout(() => {
          // initializeSlider2();
        }, 100);
      }
    }
  });
  
  // TRENDING SECTION CARD SLIDER
  const TrendingSlider = $(".trending-slider");
  const FiveProgressBar = $(".progressBar5");
  TrendingSlider.on("init", function (event, slick) {
    updateProgressBar(TrendingSlider, FiveProgressBar);
  });
  TrendingSlider.on("afterChange", function (event, slick) {
    updateProgressBar(TrendingSlider, FiveProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $FiveStatus = $(".pagingInfo5");
  var $TrendingSlider = $(".trending-slider");
  $TrendingSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $FiveStatus.text(i + "/" + slick.slideCount);
    }
  );
  TrendingSlider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.5,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.7,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1.4,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1.2,
          dots: true,
          arrows: false,
        },
      },
    ],
  });

  const SpotlightSlider2 = $(".spotlight-slider-2");
  const SixProgressBar = $(".progressBar6");
  SpotlightSlider2.on("init", function (event, slick) {
    updateProgressBar(SpotlightSlider2, SixProgressBar);
  });
  SpotlightSlider2.on("afterChange", function (event, slick) {
    updateProgressBar(SpotlightSlider2, SixProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $SixStatus = $(".pagingInfo6");
  var $SpotlightSlider2 = $(".spotlight-slider-2");
  $SpotlightSlider2.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $SixStatus.text(i + "/" + slick.slideCount);
    }
  );
  SpotlightSlider2.slick({
    settings: "unslick",
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          dots: true,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          dots: true,
          infinite: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          dots: true,
          infinite: false,
        },
      },
    ],
  });
  // PRODUCT DETAILS BANNER SLIDER
  $(".product-for-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    asNavFor: ".product-nav-slider",
  });
  var helpers = {
    addZeros: function (n) {
      if (n.length > 3) {
        return `+${n.length - 4}`;
      }
      return n < 1 ? "" + (n - 4) : "" + n;
    },
  };
  function sliderInit() {
    var $slider = $(".product-nav-slider");
    $slider.each(function () {
      var $sliderParent = $(this).parent();
      $(this).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        vertical: true,
        verticalSwiping: true,
        asNavFor: ".product-for-slider",
        dots: false,
        arrows: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 4,
              vertical: false,
              verticalSwiping: false,
            },
          },
        ],
      });
      if ($(this).find(".item").length > 1) {
        $(this).siblings(".slides-numbers-1").show();
      }
      var sliderItemsNum = $(this).find(".slick-slide").not(".slick-cloned");
      if (sliderItemsNum.length <= 4) {
        let counter1 = $("#count-box");
        counter1.addClass("d-none");
        let counterTransform1 = $(".product-nav-slider .slick-track");
        counterTransform1.addClass("transform-none");
      }
      $sliderParent
        .find(".slides-numbers-1 .total")
        .html(helpers.addZeros(sliderItemsNum));
    });
  }
  sliderInit();
  // PRODUCT DETAILS BANNER MODAL SLIDER
  $(".modal-for-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    asNavFor: ".modal-nav-slider",
  });
  var helper = {
    addZero: function (f) {
      const windowWidth = $(window).width();
      if (windowWidth <= 575) {
        // Condition for screen widths less than or equal to 575px
        if (f.length > 3) {
          return `+${f.length - 4}`;
        }
        return f < 1 ? "" + (f - 4) : "" + f;
      } else if (windowWidth <= 1499) {
        // Condition for screen widths less than or equal to 1499px
        if (f.length > 2) {
          return `+${f.length - 3}`;
        }
        return f < 2 ? "" + (f - 3) : "" + f;
      } else {
        // Condition for screen widths greater than 1499px
        if (f.length > 3) {
          return `+${f.length - 4}`;
        }
        return f < 1 ? "" + (f - 4) : "" + f;
      }
    },
  };
  function ModalSliderInit() {
    var $modalSlider = $(".modal-nav-slider");
    $modalSlider.each(function () {
      var $modalSliderParent = $(this).parent();
      $(this).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        vertical: true,
        verticalSwiping: true,
        asNavFor: ".modal-for-slider",
        dots: false,
        arrows: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 4,
              vertical: false,
              verticalSwiping: false,
            },
          },
        ],
      });
      if ($(this).find(".item").length > 1) {
        $(this).siblings(".slides-numbers-2").show();
      }
      var modalSliderItemsNum = $(this)
        .find(".slick-slide")
        .not(".slick-cloned");
      if (modalSliderItemsNum.length <= 5) {
        let counter2 = $("#count-box-2");
        counter2.addClass("d-none");
        let counterTransform2 = $(".modal-nav-slider .slick-track");
        counterTransform2.addClass("transform-none");
      }
      $modalSliderParent
        .find(".slides-numbers-2 .total-count")
        .html(helper.addZero(modalSliderItemsNum));
    });
  }
  ModalSliderInit();
  //LATEST PRODUCT SLIDER
  $(".latest-product-slider").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.5,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: "unslick",
      },
    ],
  });
  // REVIEW SECTION SLIDER
  const ReviewSlider = $(".review-card-box");
  const ProgressBarReview = $(".progressBar-reviewCard");
  ReviewSlider.on("init", function (event, slick) {
    updateProgressBar(ReviewSlider, ProgressBarReview);
  });
  ReviewSlider.on("afterChange", function (event, slick) {
    updateProgressBar(ReviewSlider, ProgressBarReview);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $ReviewStatus = $(".pagingInfo-reviewCard");
  var $ReviewSlider = $(".review-card-box");
  $ReviewSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $ReviewStatus.text(i + "/" + slick.slideCount);
    }
  );
  ReviewSlider.slick({
    settings: "unslick",
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          dots: true,
          infinite: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.3,
          dots: true,
          infinite: false,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          dots: true,
          infinite: false,
        },
      },
    ],
  });
  // PRODUCT TOTAL IMAGE COUNT
  $.fn.setMaxDimensions = function () {
    let maxHeight = 0;
    let maxWidth = 0;
    $(this).each(function () {
      if ($(this).height() > maxHeight) {
        maxHeight = $(this).height();
      }
      if ($(this).width() > maxWidth) {
        maxWidth = $(this).width();
      }
    });
    $(this).each(function () {
      $(this).height(maxHeight);
      $(this).width(maxWidth);
    });
  };
  $(".product-nav-slider .slick-slide, .slides-numbers-1").setMaxDimensions();
  $(".modal-nav-slider .slick-slide, .slides-numbers-2").setMaxDimensions();
  // TOP BANNER ALL SERVICES
  $(".service-list-slider").slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  // SERVICES BANNER DESCRIPTION VIEW EVENT
  $(".service-description-block .view-all").click(function () {
    $(".service-description-view").toggleClass("description-more");
    if ($(".service-description-block .view-all").text() == "Meer lezen") {
      $(this).text("Gelezen minder");
    } else {
      $(this).text("Meer lezen");
    }
  });
  // SHOWROOM GALLERY SLIDER
  const gallerySlider = $(".showroom-gallery-slider");
  const galleryProgressBar = $(".galleryProgressBar");
  gallerySlider.on("init", function (event, slick) {
    updateProgressBar(gallerySlider, galleryProgressBar);
  });
  gallerySlider.on("afterChange", function (event, slick) {
    updateProgressBar(gallerySlider, galleryProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $galleryStatus = $(".galleryPagingInfo");
  var $gallerySlider = $(".showroom-gallery-slider");
  $gallerySlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $galleryStatus.text(i + "/" + slick.slideCount);
    }
  );
  gallerySlider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.7,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  });
  // COLLECTION TOP BANNER VIEW EVENT
  // $(".collection-banner-description .view-more").click(function () {
  //   $(".collection-banner-description").toggleClass("description-more");
  //   if ($(".collection-banner-description .view-more").text() == "Meer lezen") {
  //     $(this).text("Minimaliseren");
  //   } else {
  //     $(this).text("Meer lezen");
  //   }
  // });
  // MOST RECENT BLOG SLIDER
  const RecentBlogSlider = $(".most-recent-blog-slider");
  const RecentBlogProgressBar = $(".recentBlogProgressBar");
  RecentBlogSlider.on("init", function (event, slick) {
    updateProgressBar(RecentBlogSlider, RecentBlogProgressBar);
  });
  RecentBlogSlider.on("afterChange", function (event, slick) {
    updateProgressBar(RecentBlogSlider, RecentBlogProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $RecentBlogStatus = $(".recentBlogPagingInfo");
  var $RecentBlogSlider = $(".most-recent-blog-slider");
  $RecentBlogSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $RecentBlogStatus.text(i + "/" + slick.slideCount);
    }
  );
  RecentBlogSlider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,

    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.6,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.7,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  });
  // PRODUCT CART MODAL SLIDER
  const PurchaseProductSlider = $(".shopping-card-slider");
  const PurchaseProductProgressBar = $(".purchaseProgressBar");
  PurchaseProductSlider.on("init", function (event, slick) {
    updateProgressBar(PurchaseProductSlider, PurchaseProductProgressBar);
  });
  PurchaseProductSlider.on("afterChange", function (event, slick) {
    updateProgressBar(PurchaseProductSlider, PurchaseProductProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $PurchaseProductStatus = $(".purchasePagingInfo");
  var $PurchaseProductSlider = $(".shopping-card-slider");
  $PurchaseProductSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $PurchaseProductStatus.text(i + "/" + slick.slideCount);
    }
  );
  PurchaseProductSlider.slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.7,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1.6,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1.2,
          dots: true,
          arrows: false,
        },
      },
    ],
  });
  // PRODUCT DETAILS STICKY BOX IN DESKTOP
   function isElementVisible(el) {
      const rect = el.getBoundingClientRect();
      const vWidth = window.innerWidth || doc.documentElement.clientWidth;
      const vHeight = window.innerHeight || doc.documentElement.clientHeight;
  
      // Check if the element is out of bounds
      if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) return false;
  
      // Return true if any of the above disjunctions are false
      return true;
    }
  $(window).bind("scroll", function () {
    var navHeight = $(".product-detail-banner").height() - 20;
    const productBoxBottom = document.querySelector('.product-box-bottom');
    
    if ($(window).scrollTop() > navHeight) {
      if(isElementVisible(productBoxBottom)){
        $(".product-box-main").removeClass("product-box-sticky");
      }else{
        $(".product-box-main").addClass("product-box-sticky");
      }
    } else {
      $(".product-box-main").removeClass("product-box-sticky");
    }
  });
  // COLLECTION DETAILS IN MOBILE STICKY SHOPPING CART
  // $(window).bind("scroll", function () {
  //   var navHeight = $(".product-detail-block").height() + 50;
  //   if ($(window).scrollTop() > navHeight) {
  //     $(".order-box").addClass("order-sticky");
  //   } else {
  //     $(".order-box").removeClass("order-sticky");
  //   }
  // });
  //
// COLLECTION DETAILS IN MOBILE STICKY SHOPPING CART
  // $(window).bind("scroll", function () {
  //   var navHeight = $(".product-detail-block").height() + 50;
  //   if ($(window).scrollTop() > navHeight) {
  //     $(".order-box").addClass("order-sticky");
  //   } else {
  //     $(".order-box").removeClass("order-sticky");
  //   }
  // });
});



$(".mobile-facets__open").click(function () {
  $("header").addClass("head-active");
});

// 10-12-24 START
$(document).ready(function () {
  // DE SERIES BANNER DETAILS SHOW
  // $(".deSeries-detail .show-btn").click(function () {
  //   const button = $(this);
  //   $(".deSeries-detail").toggleClass("box-active");
  //   if (button.text().trim() === "Meer lezen") {
  //     button.text("Gelezen minder");
  //   } else {
  //     button.text("Meer lezen");
  //   }
  // });
  // popular-series-slider
  $(".popular-series-slider").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  // series banner slider
  $(".deSeries-detail-slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 2000,
  });
  // DE SERIES MORE CARD
  $(".series-card-sec .series-card").slice(0, 9).show();
  $("#series-more-btn").on("click", function (e) {
    e.preventDefault();
    $(".series-card:hidden").slice(0, 9).slideDown();
    if ($(".series-card:hidden").length == 0) {
      $("#series-more-btn").css("display","none");
    }
  });



  
});

// 10-12-24 END




// TOP BANNER COLLECTION LIST SLIDER
    // $(".collection-banner .collection-list-slider").slick({
    //   infinite: false,
    //   slidesToShow: 7,
    //   slidesToScroll: 1,
    //   variableWidth: true,
    //   responsive: [
    //     {
    //       breakpoint: 1600,
    //       settings: {
    //         slidesToShow: 6,
    //       },
    //     },
    //      {
    //       breakpoint: 1440,
    //       settings: {
    //         slidesToShow: 6,
    //       },
    //     },
    //     {
    //       breakpoint: 1400,
    //       settings: {
    //         slidesToShow: 6,
    //       },
    //     },
    //     {
    //       breakpoint: 1200,
    //       settings: {
    //         slidesToShow: 6,
    //       },
    //     },
    //     {
    //       breakpoint: 992,
    //       settings: {
    //         slidesToShow: 5,
    //       },
    //     },
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 3,
    //       },
    //     },
    //     {
    //       breakpoint: 576,
    //       settings: {
    //         slidesToShow: 1,
    //       },
    //     },
    //   ],
    // });
    // PRODUCT LIST SLIDER





document.querySelectorAll('script[type="text/lazyload"]').forEach((script) => {
  const newScript = document.createElement('script');
  newScript.text = script.textContent;
  document.body.appendChild(newScript);
});




// product series section script start

   // product series SECTION CARD SLIDER
  $(document).ready(function () {
  const TrendingSlider = $(".series-slider");
  const FiveProgressBar = $(".progressBar55");
  TrendingSlider.on("init", function (event, slick) {
    updateProgressBar(TrendingSlider, FiveProgressBar);
  });
  TrendingSlider.on("afterChange", function (event, slick) {
    updateProgressBar(TrendingSlider, FiveProgressBar);
  });
  function updateProgressBar(sliderElement, progressBarElement) {
    const currentDot =
      sliderElement.find(".slick-dots .slick-active").index() + 1;
    const dots = sliderElement.find(".slick-dots li").length;
    const calc = (currentDot / dots) * 100;
    progressBarElement
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);
  }
  var $FiveStatus = $(".pagingInfo55");
  var $TrendingSlider = $(".series-slider");
  $TrendingSlider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $FiveStatus.text(i + "/" + slick.slideCount);
    }
  );
  TrendingSlider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.5,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.7,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1.4,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1.2,
          dots: true,
          arrows: false,
        },
      },
    ],
  });
});
// product series section script end




// collection banner slider start
$(document).ready(function () {
$(".collection-banner .collection-list-slider").slick({
      infinite: false,
      slidesToShow: 7,
      slidesToScroll: 1,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 6,
          },
        },
         {
          breakpoint: 1440,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
});
// collection banner slider end


// Collection usp slider script start
$(document).ready(function () {
  $(".collection-product-list .product-list").not('.slick-initialized').slick({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          autoplay: true,
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          autoplay: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          autoplay: true,
          slidesToShow: 1.4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: true,
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 576,
        settings: {
          autoplay: true,
          slidesToShow: 1,
        },
      },
    ],
  });
});
// Collection usp slider script end
// Landing review slider script
$(document).ready(function() {
    $(".review-slider").slick({
        arrows: true,
        loop: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 1000,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1900,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 447,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });
});
// Landing review slider script end


// crisp click events
 $(document).on("click", 'span[role="button"][aria-label="Sluit de chat"]', function() {
   $crisp.push(["do", "chat:close"]);
   // $crisp.push(["do", "chat:hide"]);
});
$(document).on("click", '.custom_chaticon', function() {
   $(this).addClass("widget-opened");
  $crisp.push(['do', 'chat:show']);
  $crisp.push(['do', 'chat:open']);
});
// crisp click events



